"use strict";

exports.__esModule = true;
exports.ClassificationButton = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _ClassificationButton = require("./ClassificationButton.legacy");
var _ClassificationButton2 = require("./ClassificationButton.modern");
// Flag-gated UI: `ClassificationButton.legacy` is the component as it is on master,
// `ClassificationButton.modern` the ui-charts-update rewrite. The nearest UiDesignProvider
// (ENABLE_MODERN_UI + the screen's flag) decides which one renders.
var ClassificationButton = exports.ClassificationButton = (0, _uiSwitch.uiSwitch)(_ClassificationButton.ClassificationButton, _ClassificationButton2.ClassificationButton, "ClassificationButton");